import dayjs from 'dayjs';

import { ValidateInfo } from './types';
import { ParamItem } from '@/api/services/parameterSchemaService';

export function formatNum(val: string) {
  const num = parseFloat(val);
  return isNaN(num) ? undefined : num;
}

export function isNullLike(val: any): val is undefined | null {
  return val === undefined || val === null;
}

export function isEmpty(val: any): val is undefined | null {
  return val === undefined || val === null || val === '';
}

export function emptyValidator(val: any, enableEmpty?: boolean) {
  return !enableEmpty &&
    (isNullLike(val) ||
      (val instanceof Array && !val.length) ||
      (typeof val === 'string' && !val))
    ? 'Should not be empty'
    : '';
}

export function numRangeValidator(
  val: { min?: string; max?: string },
  enableEmpty?: boolean,
) {
  let error = emptyValidator(val?.min, enableEmpty);
  if (error) {
    // return { min: error }
    return `Min: ${error}`;
  }
  error = emptyValidator(val?.max, enableEmpty);
  if (error) {
    // return { max: error }
    return `Max: ${error}`;
  }
  return +val.min! > +val.max! ? 'Max should bigger than Min' : '';
}

export function expiryValidator(val: string, enableEmpty?: boolean) {
  const error = emptyValidator(val, enableEmpty);
  if (error) return error;
  // const $val = dayjs(val.replace(/([a-zA-Z]+)/, ' $1 '), 'D MMM YY')
  //   .format('DMMMYY')
  //   .toUpperCase();
  // if ($val !== val && `0${$val}` !== val) return 'Out of format';
  return '';
}

export function expiriesValidator(val: string[]) {
  if (!val?.length) return '';
  for (let i = 0; i < val.length; i++) {
    const error = emptyValidator(val[i]);
    if (error) {
      // return { [i]: error }
      return `The ${i + 1}${
        i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'
      } item: ${error}`;
    }
  }
  return '';
}

export function keyValidator(val: string, allKeys: string[]) {
  const error = emptyValidator(val);
  if (error) return error;
  if (!/^[_.a-zA-Z0-9]+$/.test(val)) {
    return 'Out of format: should be a combination of the following chars `_.0-9a-zA-Z`';
  }
  const has = allKeys.some(it => val === it);
  if (has) return 'This key has been used';
  return '';
}

export function isExpired(val?: string) {
  if (!val) return false;
  const now = dayjs();
  const expiry = dayjs(
    val
      .match(/\d+|[a-zA-Z]+/g)
      ?.slice(0, 3)
      .join('-') || '',
    'D-MMM-YY',
  );
  const expireTime = dayjs(`${expiry.format('YYYY-MM-DD')}T08:00Z`);
  return now >= expireTime;
}

export function sameGroupNameValidator(
  val: string,
  paramList: ParamItem[],
  projectName: string,
  templateName: string,
  parentNames?: string,
) {
  const error = emptyValidator(val);
  if (error) return error;
  const hasSame = paramList?.some(_it => _it.name === val);
  return hasSame
    ? `该参数组名称在${projectName}>${templateName}${
        parentNames ? '>' + parentNames : ''
      }下已存在`
    : '';
}

export function validatorCvt(
  validator: (val: any, values: any) => ValidateInfo['string'],
  form?: () => any,
) {
  return (_: any, val: any) => {
    const $form = form?.();
    const error = validator(val, $form?.getFieldsValue());
    if (!error) return Promise.resolve();
    const traverse = (obj: ValidateInfo['string']): void | Promise<any> => {
      if (typeof obj === 'string' && obj) return Promise.reject(new Error(obj));
      if (obj && typeof obj === 'object') {
        for (const key in obj) {
          const res = traverse(obj[key]);
          if (res) return res;
        }
      }
    };
    return traverse(error) || Promise.resolve();
  };
}
